/*
 * Render SchemaTagInputs for create. Handle change of schema by defaulting tags to schema's fields.
 */
import PropTypes from 'prop-types';
import React from 'react';

import * as FileConstants from 'folder-items/FileConstants';
import * as SchemaFieldConstants from 'schemas/fields/SchemaFieldConstants';
import {Schema} from 'schemas/SchemaConstants';
import SchemaTagInputs from 'schemas/tags/SchemaTagInputs';
import * as TagUtil from 'schemas/tags/TagUtil';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {LabelStyle} from 'ui-library/inputs/InputConstants';

export interface SchemaTagInputsWithDefaultProps {
  labelStyle?: LabelStyle;
  itemLinkAllowed?: boolean;
  onChange: (tags: Array<FileConstants.SchemaTag>) => void;
  schema: Pick<Schema, 'id' | 'fields'> | null;
  tags: Array<FileConstants.SchemaTag>;
  tagPopovers?: {[id: string]: string | null};
}

export default class SchemaTagInputsWithDefault extends React.Component<SchemaTagInputsWithDefaultProps> {
  static propTypes = {
    labelStyle: PropTypes.oneOf(Object.values(FieldLabel.STYLES)),
    onChange: PropTypes.func.isRequired,
    schema: PropTypes.shape({
      id: PropTypes.string,
      fields: PropTypes.arrayOf(SchemaFieldConstants.SCHEMA_FIELD_SHAPE.isRequired).isRequired,
    }),
    tags: PropTypes.arrayOf(FileConstants.TAG_SHAPE.isRequired).isRequired,
  };

  override UNSAFE_componentWillMount(): void {
    this._setInitialTags(this.props);
  }

  override UNSAFE_componentWillReceiveProps(nextProps: SchemaTagInputsWithDefaultProps): void {
    if (this.props.schema?.id !== nextProps.schema?.id) {
      this._setInitialTags(nextProps);
    }
  }

  _setInitialTags({onChange, schema, tags: overrideTags}: SchemaTagInputsWithDefaultProps): void {
    const initialTags = schema ? TagUtil.getInitialTags(schema.fields) : [];
    const overrideTagById = new Map(overrideTags.map((tag) => [tag.tagSchemaField.apiId, tag]));
    // If tags for the schema are passed in, use them. Otherwise, make empty tags
    const newTagsWithOverrides = initialTags.map((tag) => {
      const overrideTag = overrideTagById.get(tag.tagSchemaField.apiId);
      return overrideTag || tag;
    });
    onChange(newTagsWithOverrides);
  }

  override render(): JSX.Element {
    const {labelStyle, itemLinkAllowed, onChange, tags, tagPopovers} = this.props;
    return (
      <SchemaTagInputs
        labelStyle={labelStyle}
        isCreating={true}
        itemLinkAllowed={itemLinkAllowed ?? true}
        onUpdateTags={onChange}
        tags={tags}
        tagPopovers={tagPopovers}
      />
    );
  }
}
